/**
 *
 * FileRow
 * Renders the upload status of a single GPX file.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CheckIcon from 'components/CheckIcon';
import { red700 } from 'styles/colors';
import {
  STATUS_PENDING,
  STATUS_UPLOADING,
  STATUS_SUCCESS,
  STATUS_ERROR,
} from './constants';
import messages from './messages';

const Row = styled.li`
  display: flex;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #eee;
  svg {
    margin-right: 10px;
  }
  .error {
    color: ${red700};
    margin-left: 10px;
  }
  a {
    margin-left: 10px;
  }
`;

const STATUS_MESSAGES = {
  [STATUS_PENDING]: messages.statusPending,
  [STATUS_UPLOADING]: messages.statusUploading,
  [STATUS_SUCCESS]: messages.statusSuccess,
};

function FileRow(props) {
  const { entry } = props;
  const { name, status, routeId, error } = entry;
  return (
    <Row>
      {status === STATUS_PENDING && <FontAwesomeIcon icon="hourglass" />}
      {status === STATUS_UPLOADING && <FontAwesomeIcon icon="spinner" spin />}
      {status === STATUS_SUCCESS && <CheckIcon check />}
      {status === STATUS_ERROR && <CheckIcon check={false} />}
      <span>{name}</span>
      {STATUS_MESSAGES[status] && (
        <span className="sr-only">
          <FormattedMessage {...STATUS_MESSAGES[status]} />
        </span>
      )}
      {status === STATUS_SUCCESS && (
        <Link to={`/route/${routeId}`}>
          <FormattedMessage {...messages.viewRoute} />
        </Link>
      )}
      {status === STATUS_ERROR && <span className="error">{error}</span>}
    </Row>
  );
}

FileRow.propTypes = {
  entry: PropTypes.shape({
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
  }).isRequired,
};

export default FileRow;
